import React from "react"
import Typography from "../Typography"

interface Props {
  error: boolean
  message: string
  className?: string
}

const ErrorLabel = ({ error, message, className }: Props) => {
  return (
    <>
      {error ? (
        <Typography color="error" textClassName={className}>
          {message}
        </Typography>
      ) : undefined}
    </>
  )
}

export default ErrorLabel
